import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useAdminTableActionsStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: designTokens.spacing[1],
    width: "100%",
  },

  actionButton: {
    width: designTokens.controlHeight.sm,
    height: designTokens.controlHeight.sm,
    minWidth: designTokens.controlHeight.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    ...shorthands.border("none"),
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.neutral[600],
    cursor: "pointer",
    transition: `all ${designTokens.transition.fast}`,
    flexShrink: 0,
    "& svg": {
      width: designTokens.iconSize.sm,
      height: designTokens.iconSize.sm,
    },
    ":not(:disabled):hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.neutral[700],
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      backgroundColor: "transparent",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "3px",
    },
  },

  actionSlotHidden: {
    width: designTokens.controlHeight.sm,
    height: designTokens.controlHeight.sm,
    minWidth: designTokens.controlHeight.sm,
    flexShrink: 0,
    visibility: "hidden",
  },

  nonInteractiveBadge: {
    width: designTokens.controlHeight.sm,
    height: designTokens.controlHeight.sm,
    minWidth: designTokens.controlHeight.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: designTokens.neutral[600],
    flexShrink: 0,
    cursor: "default",
    "& svg": {
      width: designTokens.iconSize.sm,
      height: designTokens.iconSize.sm,
    },
  },
});
